<style lang="scss" scoped>
	@import "./homePage.css";
	.ratio_class{
		height: 450px !important;
	}
	@media screen and (min-width:2200px){
		.ratio_class{
			height: 600px !important;
		}
	}
</style>

<template>
	<div id="homePage" style="width:100%;height:100%;">
		<a-row>
			<a-col :xl="{ span: 7 }">
				<div class="firstView firstView1">
					<div class="viewTitle">開戶統計</div>
					<div class="firstViewList">
						<p class="p1">今日</p>
						<p class="p2"><span class="span1 color1">{{kaihuCense.today}}</span></p>
					</div>
					<div class="firstViewList">
						<p class="p1">昨日</p>
						<p class="p2"><span class="span1 color2">{{kaihuCense.yesterday}}</span></p>
					</div>
					<div class="firstViewList">
						<p class="p1">本月</p>
						<p class="p2"><span class="span1 color3">{{kaihuCense.currentmonth}}</span></p>
					</div>
					<div class="firstViewList">
						<p class="p1">上月</p>
						<p class="p2"><span class="span1 color4">{{kaihuCense.lastmonth}}</span></p>
					</div>
				</div>
			</a-col>
			<a-col :xl="{ span: 10}" style="height:463px;">
				<map-chart ref="mapChart" :dataBol="dataBol" :widthPxMess="widthPxMess" :mapMess="mapMess"></map-chart>
			</a-col>
			<a-col :xl="{ span: 7 }">
				<div class="firstView">
					<div class="viewTitle">開戶管理</div>
					<div class="firstViewList">
						<p class="color1 p1">客服審核</p>
						<p class="p2">{{managementCense.admin1unfinish}}/<span
								class="span1 color1">{{managementCense.admin1finish}}</span></p>
					</div>
					<div class="firstViewList">
						<p class="color2 p1">中台審核</p>
						<p class="p2">{{managementCense.admin2unfinish}}/<span
								class="span1 color2">{{managementCense.admin2finish}}</span></p>
					</div>
					<div class="firstViewList">
						<p class="color3 p1">後台審核</p>
						<p class="p2">{{managementCense.admin3unfinish}}/<span
								class="span1 color3">{{managementCense.admin3finish}}</span></p>
					</div>
					<div class="firstViewList">
						<p class="color4 p1">授權審批</p>
						<p class="p2">{{managementCense.admin4unfinish}}/<span
								class="span1 color4">{{managementCense.admin4finish}}</span></p>
					</div>
				</div>
			</a-col>
			<a-col :xl="{ span: 7 }">
				<pie-chart :ref="kaihuTypeCense.id" :dataBol="dataBol" :widthPxMess="widthPxMess"
					:useData="kaihuTypeCense"></pie-chart>
				<div style="height:12px;"></div>
				<line-chart :ref="navCense.id" :dataBol="dataBol" :widthPxMess="widthPxMess" :useData="navCense">
				</line-chart>
			</a-col>
			<a-col :xl="{ span: 10}">
				<div class="secondView">
					<div class="viewTitle">開戶進度</div>
					<speed-of-progress style="height:calc(100% - 50px);"></speed-of-progress>
				</div>
			</a-col>
			<a-col :xl="{ span: 7 }">
				<!-- <pie-chart :ref="kaihuTypeCense.id" :dataBol="dataBol" :widthPxMess="widthPxMess" :useData="kaihuTypeCense"></pie-chart> -->
				<!-- <bar-chart :ref="incomeCense.id" :dataBol="dataBol" :widthPxMess="widthPxMess" :useData="incomeCense"></bar-chart> -->
				<!-- <pie-chart :ref='marketCense.id' :dataBol="dataBol" :widthPxMess="widthPxMess" :useData="marketCense"> -->
				<line-chart :ref="marketCense.id" :dataBol="dataBol" :widthPxMess="widthPxMess" :useData="marketCense">
				</line-chart>
				<!-- </pie-chart> -->
				<div style="height:12px;"></div>
				<bar-chart :ref="assessScoreCense.id" :dataBol="dataBol" :widthPxMess="widthPxMess"
					:useData="assessScoreCense"></bar-chart>
			</a-col>
			<a-col :xl="{ span: 7 }">
				<div class="thirdView ratio_class">
					<div class="viewTitle">投資目標</div>
					<div class="thirdListView" style="margin-top:10px;">
						<div v-for="(item,index) in investmentCense" v-bind:key="item.name" class="thirdList"
							style=" margin: .6rem 0;">
							<div class="thirdListTitle"><span>{{item.title}}</span><span
									style="margin-left:auto;margin-right: calc(2.5em + 8px);">占總人數比</span></div>
							<a-progress :strokeWidth=18 :percent="item.per" :strokeColor="investmentCenseColor[index]">
								<template #format="percent">
									<span :style="'color: '+investmentCenseColor[index]+';'"
										class="progressSpan">{{ percent }}%</span>
								</template>
							</a-progress>
						</div>
					</div>
				</div>

				<!-- <bar-chart :ref="investmentCense.id" :dataBol="dataBol" :widthPxMess="widthPxMess" :useData="investmentCense"></bar-chart> -->
			</a-col>
			<a-col :xl="{ span: 10}">
				<line-chart :ref="experienceCense.id" :dataBol="dataBol" :widthPxMess="widthPxMess"
					:useData="experienceCense"></line-chart>
			</a-col>
			<a-col :xl="{ span: 7 }">
				<pie-chart :ref="ageCense.id" :dataBol="dataBol" :widthPxMess="widthPxMess" :useData="ageCense">
				</pie-chart>
			</a-col>
			<a-col :xl="{ span: 7 }">
				<pie-chart :ref="employCense.id" :dataBol="dataBol" :widthPxMess="widthPxMess" :useData="employCense">
				</pie-chart>
			</a-col>
			<a-col :xl="{ span: 10}">
				<bar-chart :ref="fundsSourceCense.id" :dataBol="dataBol" :widthPxMess="widthPxMess"
					:useData="fundsSourceCense"></bar-chart>
			</a-col>
			<a-col :xl="{ span: 7 }">
				<div class="thirdView ratio_class">
					<div class="viewTitle">教育程度</div>
					<div class="thirdListView" style="margin-top:40px;">
						<div v-for="(item,index) in educationCense" v-bind:key="item.name" class="thirdList">
							<div class="thirdListTitle"><span>{{item.title}}</span><span
									style="margin-left:auto;margin-right: calc(2.5em + 8px);">占總人數比</span></div>
							<a-progress :strokeWidth=28 :percent="item.per" :strokeColor="educationCenseColor[index]">
								<template #format="percent">
									<span :style="'color: '+educationCenseColor[index]+';'"
										class="progressSpan">{{ percent }}%</span>
								</template>
							</a-progress>
						</div>
					</div>
				</div>
			</a-col>
		</a-row>
	</div>
</template>

<script>
	import https from '@/plugins/http.js';
	import apiUrl from '@/assets/api.js';
	import App from '@/assets/app.js';

	import mapChart from '@/components/chart/mapChart.vue';
	import barChart from '@/components/chart/barChart.vue';
	import lineChart from '@/components/chart/lineChart.vue';
	import pieChart from '@/components/chart/pieChart.vue';
	import speedOfProgress from '@/components/chart/speedOfProgress.vue';

	var mapMess = {
		"status": true,
		nameArr: [{
				"China": "中国"
			},
			{
				"United States": "美國"
			},
		],
		chinalist:[],
		valueArr: [
			// {
			// 	"name": "中国",
			// 	"value": 2000,
			// 	selected:1
			// },
			// {
			// 	"name": "日本",
			// 	"value": 2000,
			// },
			// {
			// 	"name": "美国",
			// 	"value": 3000
			// }
		],
	}

	export default {
		components: {
			mapChart,
			barChart,
			lineChart,
			pieChart,
			speedOfProgress,
		},
		data() {
			return {
				fullWidth: document.documentElement.clientWidth,

				// 子組件傳值 判定是否數據接收
				dataBol: false,
				// 風險評估
				assessScoreCense: {
					id: 'barChart1'
				},
				// 年紀統計
				ageCense: {
					id: 'pieChart1'
				},
				// 資產淨值
				navCense: {
					id: 'lineChart1'
				},
				// 開戶方式
				kaihuTypeCense: {
					id: 'pieChart2'
				},
				// 年收入
				incomeCense: {
					id: 'barChart2'
				},
				// 開戶管理
				managementCense: {
					admin1finish: 0,
					admin1unfinish: 0,
					admin2finish: 0,
					admin2unfinish: 0,
					admin3finish: 0,
					admin3unfinish: 0,
					admin4finish: 0,
					admin4unfinish: 0,
				},
				// 開戶統計
				kaihuCense: {
					currentmonth: 0,
					lastmonth: 0,
					today: 0,
					yesterday: 0
				},
				// 教育程度
				educationCense: [],
				educationCenseColor: ['#325bf1', '#ff4817', '#ffd814'],
				investmentCenseColor: ['#325bf1', '#fc5469', '#ffd814', '#5ec95a', '#ff7214'],
				// 受僱狀況統計
				employCense: {
					id: 'pieChart3'
				},
				// 投資經驗
				experienceCense: {
					id: 'barChart3'
				},
				// 投資目標{id:'pieChart4'}
				investmentCense: [],
				// 資金來源
				fundsSourceCense: {
					id: 'barChart4'
				},
				//交易市场
				marketCense: {
					id: 'marketCense'
				},
				// css widthPxMess
				widthPxMess: {},
				mapMess,
			};
		},
		watch: {
			/* 监听頁面寬度變化*/
			fullWidth(val) {
				let _this = this;
				_this.fullWidth = val;
				for (var aaa in _this.$refs) {
					_this.$refs[aaa].myChart.resize();
				}
			},
		},
		created() {
			this.dataBol = false;
			this.widthCreat();
			this.messLoad();
		},
		mounted() {
			// 監視頁面寬度
			let _this = this
			window.onresize = () => {
				return (() => {
					window.fullWidth = document.documentElement.clientWidth;
					_this.fullWidth = window.fullWidth;
				})()
			}
		},
		methods: {
			widthCreat() {
				let _this = this;
				let widthPxMess = {
					XYSize: 14, //0.73
					legendSize: 14, //0.73
					legendWidth: 130, //6.8
					titleSize: 20, //1
				};

				let pxString = window.getComputedStyle(document.documentElement)["fontSize"];
				let pxNum = Number(pxString.substring(0, pxString.length - 2));

				widthPxMess.XYSize = pxNum * 0.73;
				widthPxMess.legendSize = pxNum * 0.73;
				widthPxMess.legendWidth = pxNum * 6.8;
				widthPxMess.titleSize = pxNum * 1;

				_this.widthPxMess = widthPxMess;
			},
			messLoad() {
				let _this = this;
				let json = {
					token: _this.$store.state.token,
				}
				https.fetchPost(apiUrl.firstPageStatistics, {firstPageType: 0}, json).then((data) => {
					let awD = _this.widthPxMess.legendWidth * (2 / 3);
					let bwD = _this.widthPxMess.legendWidth * (1 / 3);
					let awS = _this.widthPxMess.legendWidth * (1 / 3);
					let bwS = _this.widthPxMess.legendWidth * (2 / 3);
					if (Object.is(data.qmiscode, 1000)) {
						_this.mapMess.valueArr = data.khworldcense

						//添加有值國家的高亮顏色
						_this.mapMess.valueArr.forEach(item => {
								item.itemStyle = { color: '#ffd814' }
							// if(item.val <=2){
							// 	item.itemStyle = { color: 'pink' }
							// }
							// if(item.val >2){
							// 	item.itemStyle = { color: 'blue' }
							// }
						});
						_this.mapMess.chinalist = data.khchinacense
						// 風險評估
						let data1 = data.assessScoreCense;
						let assessScoreCense = {
							x: [],
							data: [],
							title: '風險評估',
							id: 'barChart1',
							bzBol: false
						};
						let arr = [{
								value: 0,
								itemStyle: {
									color: '#5ec95a'
								}
							},
							{
								value: 0,
								itemStyle: {
									color: '#ffd814'
								}
							},
							{
								value: 0,
								itemStyle: {
									color: '#ff7214'
								}
							},
						]
						let brr = []
						for (let a in data1) {
							assessScoreCense.x.push(a);
							brr.push(data1[a])
						}
						brr.map((ev, ind) => {
							arr[ind]['value'] = ev

						})
						assessScoreCense.data = arr
						_this.assessScoreCense = assessScoreCense;
						// 年紀統計
						let data2 = data.ageCense;
						let ageCense = {
							data: [],
							legendArr: [],
							title: '年齡統計',
							radius: '50%',
							id: 'pieChart1',
							aw: awD,
							bw: bwD
						};
						for (let a in data2) {
							ageCense.data.push({
								name: a,
								value: data2[a]
							});
							ageCense.legendArr.push(a);
						}
						_this.ageCense = ageCense;
						// 資產淨值
						let data3 = data.navCense;
						let navCense = {
							x: [],
							data: [],
							title: '資產淨值',
							id: 'lineChart1'
						};
						for (let a in data3) {
							navCense.x.push(a);
							navCense.data.push(data3[a])
						};
						navCense.series = [{
								name: '模拟数据',
								type: 'line',
								smooth: true,
								areaStyle: {
									opacity: 0.8,
									color: new _this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
										offset: 0,
										color: '#fb2b29'
									}, {
										offset: 1,
										color: '#fac93c'
									}]),
								},
								data: navCense.data
							}],
							navCense.ckname = '貨幣單位：HKD(W)';
						_this.navCense = navCense;
						// 開戶方式
						let data4 = data.kaihuTypeCense;
						let kaihuTypeCense = {
							data: [],
							legendArr: [],
							title: '開戶方式',
							radius: ['35%', '50%'],
							id: 'pieChart2',
							aw: awD,
							bw: bwD
						};
						for (let a in data4) {
							let name = '';
							if (Object.is(a, 'appointmentnum')) name = '預約開戶';
							else if (Object.is(a, 'unkhamount')) name = '未提交開戶';
							else if (Object.is(a, 'onlinecount')) name = '網上開戶';
							else if (Object.is(a, 'chequenum')) name = '支票開戶';
							kaihuTypeCense.data.push({
								name: name,
								value: data4[a]
							});
							kaihuTypeCense.legendArr.push(name);
						}
						_this.kaihuTypeCense = kaihuTypeCense;
						// 年收入
						let data5 = data.incomeCense;
						let incomeCense = {
							x: [],
							data: [],
							title: '年收入',
							id: 'barChart2',
							bzBol: true
						};
						for (let a in data5) {
							incomeCense.x.push(a);
							incomeCense.data.push(data5[a])
						}
						_this.incomeCense = incomeCense;
						// 開戶管理
						let data6 = data.managementCense;
						for (let a in data6) {
							_this.managementCense[a] = data6[a];
						}
						// 開戶統計
						let data7 = data.kaihuCense;
						for (let a in data7) {
							_this.kaihuCense[a] = data7[a];
						}
						// 教育程度
						let data8 = data.educationCense;
						let educationCense = [];
						let educationCenseAll = 0;
						for (let a in data8) {
							educationCenseAll += data8[a];
						}
						for (let a in data8) {
							educationCense.push({
								title: a,
								per: Number((data8[a] / educationCenseAll * 100).toFixed(2))
							});
						}
						_this.educationCense = educationCense;
						// 受僱狀況統計
						let data9 = data.employCense;
						let employCense = {
							data: [],
							legendArr: [],
							title: '受僱狀況統計',
							radius: '50%',
							id: 'pieChart3',
							aw: awS,
							bw: bwS
						};
						for (let a in data9) {
							employCense.data.push({
								name: a,
								value: data9[a]
							});
							employCense.legendArr.push(a);
						}
						_this.employCense = employCense;
						// 投資經驗
						let data10 = data.experienceCense;
						let experienceCense = {
							x: [],
							data: [],
							title: '投資經驗',
							id: 'barChart3'
						};
						for (let a in data10) {
							experienceCense.x.push(a);
							experienceCense.data.push(data10[a])
						}
						experienceCense.series = [{
							name: '模拟数据',
							type: 'line',
							smooth: false,
							itemStyle: {
								color: '#5abe59', //#36f3ff
								// opacity:0.7
							},

							data: experienceCense.data
						}]
						_this.experienceCense = experienceCense;
						// 投資目標
						let data11 = data.investmentCense;
						let investmentCense = [];
						let investmentCenseAll = 0;
						for (let a in data11) {
							investmentCenseAll += data11[a];
						}
						for (let a in data11) {
							investmentCense.push({
								title: a,
								per: Number((data11[a] / investmentCenseAll * 100).toFixed(2))
							});
						}
						_this.investmentCense = investmentCense;
						// 資金來源
						let data12 = data.fundsSourceCense;
						let fundsSourceCense = {
							x: [],
							data: [],
							title: '資金來源',
							id: 'barChart4',
							bzBol: false
						};
						for (let a in data12) {
							fundsSourceCense.x.push(a);
							fundsSourceCense.data.push(data12[a])
						}
						_this.fundsSourceCense = fundsSourceCense;

						// let data13 = data.marketCense;
						// let marketCense = {
						// 	data: [],
						// 	legendArr: [],
						// 	title: '交易市场',
						// 	radius: ['35%', '50%'],
						// 	id: 'marketCense',
						// 	aw: awD,
						// 	bw: awD
						// };
						// for (let a in data13) {
						// 	marketCense.data.push({
						// 		name: a,
						// 		value: data13[a]
						// 	});
						// 	marketCense.legendArr.push(a);
						// }
						// _this.marketCense = marketCense;
						let data13 = data.incomeCense
						let marketCense = {
							x: [],
							data: [],
							title: '收入狀況',
							id: 'marketCense'
						};
						for (let a in data13) {
							marketCense.x.push(a);
							marketCense.data.push(data13[a])
						};
						marketCense.series = [{
								name: '收入狀況',
								type: 'line',
								smooth: true,
								areaStyle: {
									opacity: 0.8,
									color: new _this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
										offset: 0,
										color: '#f72ea2'
									}, {
										offset: 1,
										color: '#f72941'
									}]),
								},
								data: marketCense.data
							}],
							marketCense.ckname = '貨幣單位：HKD(W)';
						_this.marketCense = marketCense;
						
						_this.dataBol = true;
					} else {
						App.oTool.warningT(data.qmismsg);
					}
				});
				setTimeout(() => {
					this.dataBol = false;
					this.messLoad();
				}, 60000);
			}
		}
	}
</script>
